import { Segmented } from "antd";
import React, { useContext } from "react";
import { livetrackingcontext } from "../../../../context/LiveTrackingContext";
import trans from "../../../../utils";

export default function TrackedTypes() {
	let { trackingType, setTrackingType, setSelectedId, setImei } =
		useContext(livetrackingcontext);
	return (
		<>
			<Segmented
				options={[
					{ label: trans("Vehicles"), value: "vehicle" },
					{ label: trans("Mobility"), value: "mobility" },
				]}
				style={{
					textTransform: "capitalize",
					borderTopLeftRadius: "16px",
					borderTopRightRadius: "16px",
				}}
				onChange={(value) => {
					setTrackingType(value);
					setSelectedId(null);
					setImei(null);
				}}
				value={trackingType}
				size="large"
				block
			/>
		</>
	);
}
